var map = {
	"./baac.svg": "0fa5",
	"./bay.svg": "04b2",
	"./bbl.svg": "ae84",
	"./bnp.svg": "ec21",
	"./boa.svg": "401f",
	"./cacib.svg": "a6cc",
	"./cimb.svg": "c645",
	"./citi.svg": "b73d",
	"./db.svg": "857a",
	"./ghb.svg": "1b8b",
	"./gsb.svg": "9c0b",
	"./hsbc.svg": "cb47",
	"./ibank.svg": "957b",
	"./icbc.svg": "1f3d",
	"./jpm.svg": "cf1b",
	"./kbank.svg": "daf4",
	"./kk.svg": "acfd",
	"./ktb.svg": "ed78",
	"./lhb.svg": "c594",
	"./mb.svg": "2750",
	"./mega.svg": "35bb",
	"./mufg.svg": "e8a0",
	"./pp.svg": "5578",
	"./rbs.svg": "042f",
	"./sc.svg": "4d30",
	"./scb.svg": "ba63",
	"./smbc.svg": "8f50",
	"./tbank.svg": "be96",
	"./tcrb.svg": "6a58",
	"./tisco.svg": "d224",
	"./tmb.svg": "997a",
	"./tmn.svg": "5874",
	"./ttb.svg": "bcba",
	"./uob.svg": "00df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17c4";